import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-wallet-info-dialog',
  templateUrl: './wallet-info-dialog.component.html',
  styleUrls: ['./wallet-info-dialog.component.scss'],
})
export class WalletInfoDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any) {}

  ngOnInit(): void {
    console.log('_data', this._data?.hideBtn);
  }
}
